module.exports = __webpack_public_path__ + "static/media/photo225.1eaaa56d.jpg";